export const environment = {
  production: false,
  apiUrl: 'https://api-dev.fishscore.app',
  apiKey: 'FDxBZeqL2cw5vPgd3m95QF6pGMjU8K',
  rootNode: 'fsResponse',
  s3ApiURL: 'https://fishscore-test.s3.eu-central-1.amazonaws.com'
};
